import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { Btn } from "../components/ui.js";

/* ============================================================
   LEVELUP ONE — 404 Not Found
   ============================================================ */

export default class NotFound extends Component {
  componentDidMount() {
    loading(false);
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="nx">
        <Navbar />
        <div className="container nx-404">
          <div>
            <div className="nx-404__code nx-gradient-text">404</div>
            <h2 className="nx-ink mt-2">ไม่พบหน้าที่คุณกำลังมองหา</h2>
            <p className="nx-muted mb-4">หน้านี้อาจถูกย้ายหรือลบไปแล้ว ลองกลับไปหน้าแรกดูนะครับ</p>
            <div className="d-flex gap-3 justify-content-center flex-wrap">
              <Btn to="/">กลับหน้าแรก</Btn>
              <Btn to="/booking" variant="ghost">ติดต่อเรา</Btn>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
